<div
  pAnimateOnScroll
  enterClass="zoomin"
  leaveClass="fadeout"
  class="justify-content-center align-items-center border-round overflow-hidden">
  @if (image()) {
    <ppg-image [url]="imgUrl()" [height]="imgHeight()" [width]="imgWidth()" [description]="imgDescription()" />
  } @else {
    <ppg-fallback-image />
  }
</div>
